import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteRolesApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteRole = createAsyncThunk('deleteRole', async (payload) => {
  return await deleteRolesApi(payload);
});

const deleteRoleSlice = createSlice({
  name: 'deleteRole', // Unique Name
  initialState,
  reducers: {
    deleteRoleReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteRole.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteRole.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteRole.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteRoleReset } = deleteRoleSlice.actions;

export default deleteRoleSlice.reducer;
